import { getProductQuery } from '../productQuery'

export interface CartQuery {
  email: boolean
  available_payment_methods: {
    code: boolean
    title: boolean
    [key: string]: any
  }
  applied_gift_cards: boolean | {
    expiration_date: boolean
    code: boolean
    applied_balance: {
      value: boolean
      [key: string]: any
    }
    current_balance: {
      value: boolean
      [key: string]: any
    }
    [key: string]: any
  }
  items: boolean | {
    id: boolean
    quantity: boolean
    prices: {
      discounts: {
        amount: {
          currency: boolean
          value: boolean
        }
        label: boolean
      }
      price: {
        currency: boolean
        value: boolean
      }
      row_total: {
        currency: boolean
        value: boolean
      }
      row_total_including_tax: {
        currency: boolean
        value: boolean
      }
      total_item_discount: {
        currency: boolean
        value: boolean
      }
    }
    product: {
      [key: string]: any // TODO: type correctly, should be same type as getProductQuery()
    }
    [key: string]: any
    __on: any // TODO: type correctly
  }
  [key: string]: any
}

export const cartQuery: CartQuery = {
  email: true,
  available_payment_methods: {
    code: true,
    title: true
  },
  applied_gift_cards: !process.env.REACT_APP_MAGENTO_CE
    ? {
      applied_balance: {
        value: true
      },
      code: true,
      current_balance: {
        value: true
      },
      expiration_date: true
    }
    : false,
  items: {
    id: true,
    quantity: true,
    prices: {
      discounts: {
        amount: {
          currency: true,
          value: true
        },
        label: true
      },
      price: {
        currency: true,
        value: true
      },
      row_total: {
        currency: true,
        value: true
      },
      row_total_including_tax: {
        currency: true,
        value: true
      },
      total_item_discount: {
        currency: true,
        value: true
      }
    },
    product: {
      ...(getProductQuery('items', {
        withBase: true,
        withCrosssell: true,
        withCustomAttributes: true,
        withOnCustomizable: true
      }, true).items)
    },
    __on: [
      {
        __typeName: 'ConfigurableCartItem',
        variant_product: {
          ...(getProductQuery('items', {
            withBase: true,
            withCustomAttributes: true
          }, true).items)
        },
        configurable_options: {
          id: true,
          option_label: true,
          value_id: true,
          value_label: true
        }
      },
      {
        __typeName: 'SimpleCartItem',
        customizable_options: {
          id: true,
          label: true,
          values: {
            id: true,
            label: true,
            price: {
              type: true,
              units: true,
              value: true
            },
            value: true
          }
        }
      }
    ]
  }
}
